/* eslint camelcase: "off" */

import lang from './lang'
import { appName, appDescription, repository, version, website, companyWebsite } from '../../package.json'

const staticAssetsDir = '/static'

const config = {
  appName,
  version,
  website,
  repository,
  appDescription,
  companyWebsite,
  staticAssetsDir,
  mobileMessageCookie: '_bcq_mobile_message',
  appNameAbbr: 'bcq',
  dark: false,
  nightShift: false,
  apiExplorerTabHeight: '30vh',
  pagesMeta: `${staticAssetsDir}/data/pages`,
  demosMeta: `${staticAssetsDir}/data/page-examples/`,
  codeMeta: `${staticAssetsDir}/code/`,
  navSections: [{
    type: 'getting-started',
    label: lang.sections['getting-started'],
    icon: 'camera-timer'
  }, {
    type: 'content',
    label: lang.sections['content'],
    icon: 'cards'
  }, {
    type: 'ui',
    label: lang.sections['ui'],
    icon: 'view-dashboard'
  }, {
    type: 'forms',
    label: lang.sections['forms'],
    icon: 'page-layout-footer'
  }, {
    type: 'directives',
    label: lang.sections['directives'],
    icon: 'xml'
  }],
  documentationExclusionPages: [
    'aspect-ratio',
    'gradient-text',
    'barebone-prop',
    'deployment',
    'development',
    'typography',
    'roadmap',
    'ripple',
    'resize',
    'tooltip',
    'theme',
    'spacing',
    'quick-start',
    'publishing',
    'reusable-css-classes',
    'colors',
    'elevation',
    'reactive-style',
    'bcq-bundler'
  ]
}

export default config



// WEBPACK FOOTER //
// ./src/helpers/config.js